<template>
  <div class="tradingview-chart">

    <UiHeader
      v-if="props.showTitle"
      :header="$t('investor.stock.quotes.tradingChart')"
      position="center"
      header-size="h5"
      header-size-tablet="h5"
      header-size-mobile="h7"
    />

    <div
      ref="container"
      class="tradingview-widget-container"
    >
      <div class="tradingview-widget-container__widget"/>

      <div class="tradingview-widget-copyright">
        <a
          href="https://www.tradingview.com/symbols/GPW-BFT/"
          target="_blank"
          rel="noopener nofollow"
        >
          <span class="blue-text">BFT stock price</span>
        </a>

        <span class="trademark">&nbsp;by TradingView</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import type { IProps } from './TradingViewChart.types'

const props = withDefaults(defineProps<IProps>(), {
  showTitle: true,
})

const container = ref(null)

onMounted(() => {
  const script = document.createElement('script')

  script.src =
    'https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js'
  script.type = 'text/javascript'
  script.async = true

  script.innerHTML = JSON.stringify({
    lineWidth: 2,
    lineType: 0,
    chartType: 'area',
    fontColor: 'rgb(106, 109, 120)',
    gridLineColor: 'rgba(46, 46, 46, 0.06)',
    volumeUpColor: 'rgba(34, 171, 148, 0.5)',
    volumeDownColor: 'rgba(247, 82, 95, 0.5)',
    backgroundColor: '#ffffff',
    widgetFontColor: '#0F0F0F',
    upColor: '#22ab94',
    downColor: '#f7525f',
    borderUpColor: '#22ab94',
    borderDownColor: '#f7525f',
    wickUpColor: '#22ab94',
    wickDownColor: '#f7525f',
    colorTheme: 'light',
    isTransparent: false,
    locale: 'en',
    chartOnly: false,
    scalePosition: 'right',
    scaleMode: 'Normal',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif',
    valuesTracking: '1',
    changeMode: 'price-and-percent',
    symbols: [['GPW:BFT|1D']],
    dateRanges: [
      '5d|1D',
      '1m|1D',
      '3m|1D',
      '12m|1D',
      '60m|1D',
      'all|1D',
    ],
    fontSize: '10',
    headerFontSize: 'medium',
    autosize: false,
    lineColor: '#0967F7',
    topColor: '#EBF4FF',
    bottomColor: '#EBF4FF',
    width: '100%',
    height: '500',
    noTimeScale: false,
    hideDateRanges: false,
    hideMarketStatus: false,
    hideSymbolLogo: false,
  })

  container.value.appendChild(script)
})
</script>

<style scoped lang="scss">
.tradingview-chart {
  @include section-investor();
}

.tradingview-widget-container {
  @include section-investor__container();
}
</style>
